import {lazy, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

// material-ui
import {Box} from '@mui/material';

import Loadable from "../../ui-component/Loadable";
import {fetchGames} from "../../store/actions";
import {Helmet} from "react-helmet";

const Competition = Loadable(lazy(() => import('./Competition')));
// ==============================|| MAIN LAYOUT ||============================== //

const Home = () => {

    const {games, games_state} = useSelector((state) => state['data']);
    const dispatch = useDispatch();

    useEffect(() => {
        if (games_state === "pre") {
            dispatch(fetchGames())
        }
    }, [games_state, dispatch]);

    return (
        <Box my={4}>
            <Helmet>
                <title>Boxing Streams - dedicated to the highest quality of free Boxing.</title>
                <link rel="canonical" href={window.location}/>
                <meta property="og:url" content={window.location}/>
            </Helmet>
            {games_state === "success" && [...new Set(games.map(g=>g.d))].map((d) => <Competition key={d} games={games.filter(g => g.d === d)}
                                                                             date={d}/>)}
        </Box>
    );
};

export default Home;